<template>
    <div class="col-lg-5 col-md-7">
        <div class="">
            <div class="px-lg-5 pt-lg-5 pb-lg-2">
                <div class="login-header text-center mb-4">{{ $t('login') }}</div>
                <base-alert type="danger" v-if="error">{{error}}</base-alert>
                <!--
                <base-alert type="danger" v-if="socEmailErrorProvider && !error">
                    Вы ранее уже регистрировались на сайте с электронной почтой указанной в вашем профиле <strong>{{socEmailErrorProvider}}</strong>.
                    Для начала войдите на сайт используя эту электронную почту и пароль, для того, чтобы затем
                    связать её с аккаунтом <strong>{{socEmailErrorProvider}}</strong>.
                </base-alert>
                -->
                <base-alert type="success" v-if="successActivation && !error">
                    {{ $t('success_activation') }}
                </base-alert>
                <base-alert type="primary" v-if="successRecovery && !error">
                    {{ $t('success_recovery') }}
                </base-alert>
                <base-alert type="primary" v-if="successShortRegistration && !error">
                    {{ $t('success_short_registration') }}
                </base-alert>
                <form role="form">
                    <base-input class="input-group-alternative mb-3"
                                ref="email"
                                :placeholder="$t('email')"
                                :error="fieldError('email')"
                                addon-left-icon="ni ni-email-83"
                                v-model="email"
                                @keyup.enter="submit">
                    </base-input>

                    <base-input class="input-group-alternative"
                                ref="password"
                                :placeholder="$t('password')"
                                :error="fieldError('password')"
                                type="password"
                                addon-left-icon="ni ni-lock-circle-open"
                                v-model="password"
                                @keyup.enter="submit">
                    </base-input>
                    <div class="text-center">
                        <base-button :disabled="!submitEnabled" class="my-4 px-5 py-3 login-btn" @click="submit">
                            {{ $t('login') }}
                        </base-button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    import userApi from "../../data/UserApi";
    import JwtService, {getUser} from "../../data/jwt.service";

    export default {
        name: 'EmailLogin',
        props: {
            defaultLogin: String,
        },
        data() {
            return {
                email: '',
                password: '',

                error: null,
                fieldsErrors: [],
                loading: false,

                loginedUser: null,

                successActivation: false,
                successRecovery: false,
                successShortRegistration: false,
                oneTimeLogin: null,
                socEmailErrorProvider: null,
            }
        },

        computed: {
            submitEnabled() {
                return this.password && this.password.length > 0
                    && this.email && this.email.length > 0
                    && !this.loginedUser
            },
        },

        filters: {
            capitalizeFirstLetter: function (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            }
        },

        methods: {
            oneTimeLoginSubmit() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                userApi.oneTimeLogin(this.oneTimeLogin)
                    .then(response => {
                        this.loginedUser = response.user
                        JwtService.saveUser(this.loginedUser)
                        userApi.pushUserContext()
                        this.loading = false
                        if ('return' in this.$route.query) this.$router.push(this.$route.query.return)
                        else window.location.href = '/'
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else if (error.response.status === 401) {
                            this.error = this.$t('link_expired')
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            submit() {
                if (!this.submitEnabled) return
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                userApi.login(this.email, this.password)
                    .then(response => {
                        this.loginedUser = response.user
                        JwtService.saveUser(this.loginedUser)
                        userApi.pushUserContext()
                        this.loading = false
                        if ('return' in this.$route.query) this.$router.push(this.$route.query.return)
                        else window.location.href = '/'
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else if (error.response.status === 401) {
                            this.error = this.$t('error_invalid_login')
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        },

        mounted() {
            if (getUser()) {
                userApi.pushUserContext()
                this.$router.push('/user/profile')
            }

            this.email = this.defaultLogin ? this.defaultLogin : ''

            this.successActivation = 'active' in this.$route.query
            this.successRecovery = 'recovery' in this.$route.query
            this.successShortRegistration = 'short' in this.$route.query
            if ('ot' in this.$route.query) {
                this.oneTimeLogin = this.$route.query.ot
                if (this.oneTimeLogin) {
                    this.oneTimeLoginSubmit();
                }
            }
            if ('error_email' in this.$route.query)
                this.socEmailErrorProvider = this.$route.query.error_email
            if ('login' in this.$route.query) {
                this.email = this.$route.query.login
            }
            if (this.email) {
                this.$refs.password.$el.querySelector('input').focus()
            } else {
                this.$refs.email.$el.querySelector('input').focus()
            }

        }
    }
</script>

<style scoped>

</style>
